import 'bootstrap5/dist/css/bootstrap.min.css';
//import 'devextreme/dist/css/dx.common.css';
import '@infoenergo/asuse-reports-ui/dist/style.css';
import '@/themes/generated/dx.material.custom-scheme.css';
import '@/themes/generated/ai.scss';
import '@/ai-scss.scss';
//import '@/themes/generated/theme.additional.css';
import '@/themes/generated/override.devex.scss';

import { createApp } from 'vue';
import router, { routes, initialRoutes } from './router';
import themes from 'devextreme/ui/themes';
import App from './App';
import appInfo from './app-info';
import { VueCookieNext } from 'vue-cookie-next';
import ruMessages from 'devextreme/localization/messages/ru.json';
import { locale, loadMessages } from 'devextreme/localization';
import store from '@/store';
import GridCard from '@/components/grid-card-component/grid-card.vue';
import RegGrid from '@/virtual/reg-grid.vue';
import { common } from '@/service/http';
import AiGridEdit from './components/ai-grid-edit/ai-grid-edit.vue';
import AiGridEditCore from './components/ai-grid-edit/ai-grid-edit-core.vue';
import AiTreeListEdit from './components/ai-tree-list-edit/ai-tree-list-edit.vue';
import AiGridRo from './components/ai-grid-ro/ai-grid-ro.vue';
import { componentGenerator } from '@/AutoComponents/generator';
import HomeViewDef from '@/views/home-view/home-view-def.vue';
import HomeViewEl from '@/views/home-view/home-view-el/home-view-el.vue';

//import NsiGroupNoteView from '@/views/nsi/nsi-group-note-view.vue';
import AccessDenied from './views/access-denied/access-denied.vue';
import NsiGroupNoteView from '@/views/nsi/nsi-group-note-view.vue';
// import VidDogPrilView from '@/views/nsi/components/forms/vid-dog-pril-form/vid-dog-pril-view.vue';
import OrgStructureView from '@/views/nsi/components/forms/org-structure-form/org-structure-view.vue';
import nsiOrgCard from '@/views/nsi/components/forms/org-structure-form/org-card';
import nsiEmpCard from '@/views/nsi/components/forms/org-structure-form/emp-card';
import { getRouteMeta, listMetaRouters } from './utils/meta-route';
import { listMetaViewsH } from './utils/meta-view';
import enviromentStore from '@/store/enviroment-data';
import vClickOutside from './utils/directives/clickOutside';
import ViewContractListSearch from '@/views/home-view/home-view-el/components/view-contract-list-search.vue';
import ViewContragentListSearch from '@/views/home-view/home-view-el/components/view-contragent-list-search.vue';
import AiHomeComponent from '@/components/ai-home/ai-home-component.vue';
import isSprDirectView from './views/mped/views/sprDirectView/is-spr-direct-view.vue';
import AiGridVirtual from '@/components/ai-grid-virtual/ai-grid-virtual.vue';
import NavigateMenuView from '@/views/mped/navigate-menu.vue';
import MpedHomeView from '@/views/mped/home/mped-home-view.vue';
import ArkiHomeView from '@/views/arki/home/arki-home-view.vue';
import ViewTepGrid from '@/views/tep/tep-grid/view-tep-grid.vue';
import TypetransView from '@/views/nsi/typetrans/typetrans-view.vue';
import { setApp } from '@/store/global';
import IsSprsmetView from './views/mped/views/sprSmetView/is-sprsmet-view.vue';
import mainLayout from '@/layouts/main-layout/main-layout.vue';
import HomeView from '@/views/home-view/home-view.vue';
import KsFsView from '@/views/nsi/ks-fs-view.vue';
import SprSmetZatrCalc from './views/mped/views/sprSmetZatrCalc/spr-smet-zatr-calc.vue';
import KsOkvedView from '@/views/nsi/ks-okved-view.vue';
import KkintervaltimeView from '@/views/nsi/kkintervaltime-view.vue';
import CalculationStringAlgorithmView from './views/mped/views/calculation/algorithm/calculation-string-algorithm-view.vue';
import QsCtpKazView from '@/views/tep/tep-nsi/qs-ctp-kaz-view.vue';
import VidDogPril from '@/views/nsi/vid-dog-pril/vid-dog-pril.vue';
import QsTempGrView from '@/views/tep/tep-nsi/qs-temp-gr-view.vue';
import QsSxprSwpView from '@/views/tep/tep-nsi/qs-sxpr-swp-view.vue';
import QsSxprGwpView from '@/views/tep/tep-nsi/qs-sxpr-gwp-view.vue';
import QsSxprStpView from '@/views/tep/tep-nsi/qs-sxpr-stp-view.vue';
import QsSxprSopView from '@/views/tep/tep-nsi/qs-sxpr-sop-view.vue';
import QsSxprQwView from '@/views/tep/tep-nsi/qs-sxpr-qw-view.vue';
import QsSxprSoView from '@/views/tep/tep-nsi/qs-sxpr-so-view.vue';
import QsSxprSwView from '@/views/tep/tep-nsi/qs-sxpr-sw-view.vue';
import AiCheckbox from '@/components/ai-checkbox.vue';
import AiTreeListEditWrapper from '@/components/wrappers/ai-tree-list-edit-wrapper.vue';
import AiGridEditWrapper from '@/components/wrappers/ai-grid-edit-wrapper.vue';
import AiGridRoWrapper from '@/components/wrappers/ai-grid-ro-wrapper.vue';
import KsBankpolView from '@/views/nsi/ks-bankpol-view.vue';
import KsIstfinView from '@/views/nsi/ks-istfin-view.vue';
import KsGroupCustView from '@/views/nsi/ks-group-cust-view.vue';
import orgContextNavigator from '@/views/context-navigator/org-context-navigator.vue';
import KsBankView from '@/views/nsi/ks-bank-view.vue';
import AiTreeListEditCore from './components/ai-tree-list-edit/ai-tree-list-edit-core.vue';
import supportPopup from './views/support/support-popup.vue';
import ToolBarPanelData from '@/layouts/main-layout/components/top-menu/ToolBarPanelData.vue';
import UserLocksPopup from '@/views/administration/users/user-locks-popup.vue';
import MassLocksPopup from '@/views/administration/users/mass-locks-popup.vue';
import QsTipPruuView from '@/views/tep/tep-nsi/qs-tip-pruu-view.vue';
import TepHomeView from '@/views/tep/tep-home-view.vue';
import DsNaznHouseView from '@/views/tep/tep-nsi/ds-nazn-house-view.vue';
import DsTipPribView from '@/views/tep/tep-nsi/ds-tip-prib-view.vue';
import DsNpotView from '@/views/tep/tep-nsi/ds-npot-view.vue';
import QkSxprisView from '@/views/tep/tep-nsi/qk-sxpris-view.vue';
import DsNpotParView from '@/views/tep/tep-nsi/ds-npot-par-view.vue';
import DkZzOtklView from '@/views/tep/tep-nsi/dk-zz-otkl-view.vue';
import BsTempGruntView from '@/views/tep/tep-nsi/bs-temp-grunt-view.vue';
import TepKsTarifNormView from '@/views/tep/tep-nsi/tep-ks-tarif-norm-view.vue';
import DsGvsNormView from '@/views/tep/tep-nsi/ds-gvs-norm-view.vue';
import DsOtopNormView from '@/views/tep/tep-nsi/ds-otop-norm-view.vue';
import DsPeriodView from '@/views/tep/tep-nsi/ds-period-view.vue';
import DsNrasxView from '@/views/tep/tep-nsi/ds-nrasx-view.vue';

const { checkAccess } = enviromentStore;
loadMessages(ruMessages);
locale(navigator.language || navigator.browserLanguage);

themes.initialized(async () => {
    const app = createApp(App);
    // async function checkHeaders() {
    //     try {
    //         const url = window.location.href + 'app-postfix';
    //         // Делаем запрос к текущей странице, чтобы получить заголовки
    //         const response = await fetch(url, {
    //             method: 'GET', // Только заголовки, без тела
    //         });
    //         const result = await response.json();
    //         // Доступные заголовки
    //         const postfix = result.value;
    //         // const environment = response.headers.get('X-Environment');
    //
    //         console.log('postfix:', postfix);
    //         // console.log('Environment:', environment);
    //         // Можно сохранить в Vuex или предоставить через provide/inject
    //         if (postfix) {
    //             window['appPostfix'] = postfix;
    //         }
    //         console.log('window["appPostfix"]:', postfix);
    //     } catch (error) {
    //         console.warn('Cannot read custom headers:', error);
    //     }
    // }
    // await checkHeaders();
    setApp(app);
    const response = await common('meta./meta/ai-components/get', {});
    if (!response.result) {
        console.log('err: ' + 'ce836aad-77c5-4647-8423-242d4786ce0c');
        return;
    }

    app.component({
        GridCard,
        RegGrid,
    });
    app.component('ai-grid-edit', AiGridEdit);
    app.component('ai-tree-list-edit', AiTreeListEdit);
    app.component('ai-grid-ro', AiGridRo);
    app.component('ai-grid-virtual', AiGridVirtual);
    app.component('ai-checkbox', AiCheckbox);
    app.component('ai-tree-list-edit-wrapper', AiTreeListEditWrapper);
    app.component('ai-grid-edit-wrapper', AiGridEditWrapper);
    app.component('ai-grid-ro-wrapper', AiGridRoWrapper);
    app.component('ai-grid-edit-core', AiGridEditCore);
    app.component('ai-tree-list-edit-core', AiTreeListEditCore);

    app.component('nsi-group-note-view', NsiGroupNoteView);
    app.component('typetrans-view', TypetransView);
    app.component('vid-dog-pril', VidDogPril);
    app.component('org-structure-view', OrgStructureView);
    app.component('nsi-org-card', nsiOrgCard);
    app.component('nsi-emp-card', nsiEmpCard);
    app.component('ks-fs-view', KsFsView);
    app.component('ks-okved-view', KsOkvedView);
    app.component('ks-bank-view', KsBankView);
    app.component('ks-bankpol-view', KsBankpolView);
    app.component('ks-istfin-view', KsIstfinView);
    app.component('ks-group-cust-view', KsGroupCustView);
    app.component('org-navigator-view', orgContextNavigator);

    app.component('mped-home-view', MpedHomeView);
    app.component('is-spr-direct-view', isSprDirectView);
    app.component('is-sprsmet-view', IsSprsmetView);
    app.component('spr-smet-zatr-calc', SprSmetZatrCalc);
    app.component('calculation-string-algorithm', CalculationStringAlgorithmView);
    app.component('kk-intervaltime-view', KkintervaltimeView);

    app.component('navigate-menu-view', NavigateMenuView);
    app.component('access-denided', AccessDenied);
    app.component('ai-home-component', AiHomeComponent);
    app.component('home-view-def', HomeViewDef);
    app.component('home-view-el', HomeViewEl);
    app.component('view-contract-list-search', ViewContractListSearch);
    app.component('view-kv-customer-search', ViewContragentListSearch);
    app.component('arki-home-view', ArkiHomeView);
    app.component('supportPopup', supportPopup);

    // region tep
    app.component('tep-home-view', TepHomeView);
    app.component('view-tep-grid', ViewTepGrid);
    app.component('qs-ctp-kaz-view', QsCtpKazView);
    app.component('qs-temp-gr-view', QsTempGrView);
    app.component('qs-sxpr-swp-view', QsSxprSwpView);
    app.component('qs-sxpr-gwp-view', QsSxprGwpView);
    app.component('qs-sxpr-sop-view', QsSxprSopView);
    app.component('qs-sxpr-stp-view', QsSxprStpView);
    app.component('qs-sxpr-qw-view', QsSxprQwView);
    app.component('qs-sxpr-so-view', QsSxprSoView);
    app.component('qs-sxpr-sw-view', QsSxprSwView);
    app.component('qs-tip-pruu-view', QsTipPruuView);
    app.component('ds-nazn-house-view', DsNaznHouseView);
    app.component('ds-tip-prib-view', DsTipPribView);
    app.component('ds-npot-view', DsNpotView);
    app.component('qk-sxpris-view', QkSxprisView);
    app.component('ds-npot-par-view', DsNpotParView);
    app.component('dk-zz-otkl-view', DkZzOtklView);
    app.component('bs-temp-grunt-view', BsTempGruntView);
    app.component('tep-ks-tarif-norm-view', TepKsTarifNormView);
    app.component('ds-gvs-norm-view', DsGvsNormView);
    app.component('ds-otop-norm-view', DsOtopNormView);
    app.component('ds-period-view', DsPeriodView);
    app.component('ds-nrasx-view', DsNrasxView);

    // endregion

    // popups
    app.component('mass-locks-popup', MassLocksPopup);
    app.component('user-locks-popup', UserLocksPopup);
    app.component('ToolBarPanelData', ToolBarPanelData);
    componentGenerator(response.data, app);
    if (routes.length === initialRoutes.length) {
        await routesProcessing();
    }
    const componentAuto = [];

    for (const component of componentAuto) {
        app.component(component.id, component.component);
    }
    app.use(VueCookieNext, {
        domain: 'asusejs-dev.infoenergo.loc',
        path: '/',
        expires: '7d',
    });
    app.config.globalProperties.$appInfo = appInfo;
    app.use(store);
    app.use(router);
    app.directive('click-outside', vClickOutside);
    app.mount('#app');
});

export const routesProcessing = async () => {
    const routesData = await listMetaRouters();
    const viewsData = await listMetaViewsH();
    router.addRoute({
        path: '/infoenergo/home/&/:app/:dep',
        name: 'home-view',
        meta: { requiresAuth: true, layout: mainLayout },
        buttonCloseHide: true,
        viewId: 'home-view',
        src: 'infoenergo/assets/home.svg',
        component: HomeView,
    });
    if (routesData.result) {
        for (const metaRout of routesData.data) {
            const routeResp = await getRouteMeta(
                metaRout.route_name,
                viewsData,
                routesData.data,
                metaRout.accessDenied
            );

            if (routeResp.result) {
                let title = metaRout.tab_title ? metaRout.tab_title : routeResp.data.name;
                const beforeEnterFunc = async (to, from, next) => {
                    const accessDenided = await checkAccess(to.name);
                    if (accessDenided && !routeResp.data.is_child) {
                        next({
                            name: 'access-denided',
                            component: AccessDenied,
                        });
                    } else {
                        next();
                    }
                };
                let route = {
                    ...routeResp.data,
                    component: routeResp.data.component,
                    viewId: routeResp.data.viewId,
                    title: title,
                    beforeEnter: beforeEnterFunc,
                };
                route.meta = !route.meta ? {} : route.meta;
                route.meta.viewId = routeResp.data.viewId;
                route.meta.title = title;
                router.addRoute(route);
            }
        }
    }
};
